module.exports = __webpack_public_path__ + "img/offline.09031218.svg";